export default __webpack_public_path__ + "efe621a.png";